module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTMnIHZpZXdCb3g9JzAgMCAxNiAxMycgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTYgMS41YzAtLjU1NS0uNDQ1LTEtMS0xSDFjLS41NTUgMC0xIC40NDUtMSAxbDggNiA4LTZ6TTAgMy4yOTdWMTEuNWMwIC41NTUuNDQ1IDEgMSAxaDE0Yy41NTUgMCAxLS40NDUgMS0xVjMuMjk3bC04IDYtOC02eicgZmlsbD0nI0ZGRicgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/contact.svg
// module id = 245
// module chunks = 114276838955818 184470312924441